export default __webpack_public_path__ + "static/media/elizabeth.519a4174.png";